import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import {
  Component,
  Inject,
  NgZone,
  PLATFORM_ID,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { People } from "../model/people";
import { Personorg } from "../model/personorg";
import { Personproject } from "@src/app/components/org/orgprojectlist/model/personproject";
import { Projectperson } from "@src/app/models/projectperson";
import { Router } from "@angular/router";

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-chart",
  templateUrl: "./chart.component.html",
  styleUrls: ["./chart.component.css"],
})
export class ChartComponent implements OnChanges {
  private root!: am5.Root;
  redered = false;
  @Input() data: any;
  @Input() people: Personorg[];
  @ViewChild('planmodal',{static:true}) planmodal:ElementRef;
  @ViewChild('closeplanmodal',{static:true}) closeplanmodal:ElementRef;
  inspectPersonProjects:string;
  modallist:Projectperson[];
  @Input() pp:Projectperson[];
  timeClicked:Date;
  @Output() doneloading =  new EventEmitter<boolean>(true);

  constructor(private router:Router) {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.data = changes.data.currentValue;
      //console.log(this.data);
    }
    if (changes.people && changes.people.currentValue) {
      this.people = changes.people.currentValue;
      //console.log(this.people);
    }
    if (this.data && this.people && !this.redered) {
      this.renderChart();
    }
  }
  

  renderChart() {
    this.redered = true;
    /* Chart code */
    // Create root element
    // https://www.amcharts.com/docs/v5/getting-started/#Root_element

    let root = am5.Root.new("chartdiv");

    const myTheme = am5.Theme.new(root);

    myTheme.rule("Label").setAll({
      fill: am5.color(0x000000),
      fontSize: "0.9em",
      fontFamily: "Lato, sans-serif",
    });

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([am5themes_Animated.new(root), myTheme]);


    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        pinchZoomX: true,
        paddingLeft: 0,
        maxTooltipDistance: -1
      })
    );

    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    let cursor = chart.set(
      "cursor",
      am5xy.XYCursor.new(root, {
        behavior: "zoomX",
      })
    );
    cursor.lineY.set("visible", true);
    let data = this.data;
    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    // let xAxis = chart.xAxes.push(
    //   am5xy.CategoryAxis.new(root, {
    //     categoryField: "Date",
    //     startLocation: 0.5,
    //     endLocation: 0.5,
    //     renderer: am5xy.AxisRendererX.new(root, {
    //       //minorGridEnabled: true,
    //       minGridDistance: 100,
    //     }),
    //     tooltip: am5.Tooltip.new(root, {}),
    //   })
    // );
    let xAxis = chart.xAxes.push(
      am5xy.DateAxis.new(root, {
        baseInterval: { timeUnit: "day", count: 1 },
        tooltipDateFormat: "EEEE dd/MM",
        startLocation: 0.5,
        endLocation: 0.5,
        autoZoom: false,
        renderer: am5xy.AxisRendererX.new(root, {
          minGridDistance: 1,
        }),
        tooltip: am5.Tooltip.new(root, {
        })
      })
    );
    xAxis.get("dateFormats")["day"] = "dd";
    xAxis.data.setAll(data);
    let xmax = this.people.length * 8;
    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        min: 0,
        max: xmax,
        strictMinMax: true,
        renderer: am5xy.AxisRendererY.new(root, {
        }),
      })
    );
    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    const createSeries = (name, field) => {
      let series = chart.series.push(
        am5xy.SmoothedXLineSeries.new(root, {
          name: name,
          xAxis: xAxis,
          yAxis: yAxis,
          stacked: true,
          valueYField: field,
          valueXField: "Date",
          tooltip: am5.Tooltip.new(root, {
            getFillFromSprite: false,
            //getStrokeFromSprite: false,
            autoTextColor: false,
            getLabelFillFromSprite: false,
            pointerOrientation: "horizontal"
          }),
        })
      );
      series.strokes.template.setAll({
        strokeWidth: 3,
      });
      series.get("tooltip").get("background").setAll({
        fill: am5.color(0x000000),
        fillOpacity: 0.7,
      });
      
      series.get("tooltip").label.adapters.add("text", function(text, target) {
        text = "";
        var i = 0;
        var tooltipDataItem = series.get("tooltipDataItem");
        if(tooltipDataItem){
          text += '[' + series.get("stroke").toString() + ']●[/] [bold width:100px]' + series.get("name") + ':[/] ' + tooltipDataItem.get("valueY");
        }
        // chart.series.each(function(series, index) {
        //   var tooltipDataItem = series.get("tooltipDataItem");
        //   if(tooltipDataItem){
        //     if(i != 0){
        //        text += "\n";
        //     }
        //     //if series is the hovered series
        //     if(series[index] == series.get("tooltipDataItem")){
        //       text += '[' + series.get("stroke").toString() + ']●[/] [bold width:100px]' + series.get("name") + ':[/] ' + tooltipDataItem.get("valueY");
        //     }else{
        //       text += '[' + series.get("stroke").toString() + ']●[/] ' + series.get("name") + ': ' + tooltipDataItem.get("valueY");
            
        //     }
        //   }
        //   i++;
        // })
        return text
      });

      
      series.fills.template.setAll({
        fillOpacity: 0.5,
        visible: true,
      });
      
      series.events.on("click",  (event) => {
        //console.log(event.target);
        this.inspectPersonProjects = event.target.get("name");
        //console.log(this.inspectPersonProjects);
        this.timeClicked = new Date(event.target.get("tooltipDataItem").get("valueX"));
        this.modallist = this.pp.filter((p) => {
          return (p.fullname == this.inspectPersonProjects &&
           new Date(p.start_date).getTime() <= event.target.get("tooltipDataItem").get("valueX") &&
           new Date(p.end_date).getTime() >= event.target.get("tooltipDataItem").get("valueX"));
        });
        this.planmodal.nativeElement.click();
      });

      series.data.setAll(data);
      series.appear(1000);
      this.doneloading.emit(true);
    }
    for(let p of this.people){
    createSeries(p.membername, p.membername);
    // createSeries("Motorcycles", "motorcycles");
    // createSeries("Bicycles", "bicycles");
    }
    var olddata;
    setInterval(() => {
      for (let s of chart.series) {
        s.data.setAll(this.data);
        
      }
      if(olddata != this.data){
        createAxisRanges();
        olddata = this.data;
      }
      this.doneloading.emit(true);
    }, 5000);

    // Create axis ranges
   const createAxisRanges = () => {
      // remove old ranges
      xAxis.axisRanges.clear();
      let  start = this.data[0].Date;// axis.positionToDate(0);
      let end = this.data[this.data.length - 1].Date;// axis.positionToDate(1)
     
      // Get weekends
      var current = new Date(start);
      while (current < end) {
        // Get weekend start and end dates
        let weekendStart = getWeekend(current);
        let weekendEnd = new Date(weekendStart);
        weekendEnd.setDate(weekendEnd.getDate() + 2);
        // Create a range
        createRange(weekendStart.getTime(), weekendEnd.getTime(), am5.color(0xff621f));
        
        
        // Iterate
        current.setDate(current.getDate() + 7);
      }
     
      function getWeekend(date) {
        let lastday = date.getDate() - (date.getDay() || 7) + 6;
        let lastdate = new Date(date);
        lastdate.setDate(lastday);
        return lastdate;
      }
    };


    createAxisRanges();
    olddata = this.data;
// Create axis ranges
function createRange(value, endValue, color) {
  var rangeDataItem = xAxis.makeDataItem({
    value: value,
    endValue: endValue
  });
  
  let range = xAxis.createAxisRange(rangeDataItem);
  
  
    rangeDataItem.get("axisFill").setAll({
      fill: color,
      fillOpacity: 0.1,
      visible: true,
    });
}





    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-ranges/
    // let rangeDataItem = xAxis.makeDataItem({
    //   category: "2001",
    //   endCategory: "2003",
    // });

    // let range = xAxis.createAxisRange(rangeDataItem);

    // rangeDataItem.get("grid").setAll({
    //   stroke: am5.color(0x00ff33),
    //   strokeOpacity: 0.5,
    //   strokeDasharray: [3],
    // });

    // rangeDataItem.get("axisFill").setAll({
    //   fill: am5.color(0x00ff33),
    //   fillOpacity: 0.1,
    //   visible: true,
    // });

    // rangeDataItem.get("label").setAll({
    //   inside: true,
    //   text: "Fines for speeding increased",
    //   rotation: 90,
    //   centerX: am5.p100,
    //   centerY: am5.p100,
    //   location: 0,
    //   paddingBottom: 10,
    //   paddingRight: 15,
    // });

    // let rangeDataItem2 = xAxis.makeDataItem({
    //   category: "2007",
    // });

    // let range2 = xAxis.createAxisRange(rangeDataItem2);

    // rangeDataItem2.get("grid").setAll({
    //   stroke: am5.color(0x00ff33),
    //   strokeOpacity: 1,
    //   strokeDasharray: [3],
    // });

    // rangeDataItem2.get("axisFill").setAll({
    //   fill: am5.color(0x00ff33),
    //   fillOpacity: 0.1,
    //   visible: true,
    // });

    // rangeDataItem2.get("label").setAll({
    //   inside: true,
    //   text: "Motorcycle fee introduced",
    //   rotation: 90,
    //   centerX: am5.p100,
    //   centerY: am5.p100,
    //   location: 0,
    //   paddingBottom: 10,
    //   paddingRight: 15,
    // });

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    chart.appear(1000, 100);
  }

  clickOnProject(pp:Projectperson){
    
    this.router.navigate(['/portal/project/'+pp.projectId]);
    this.closeplanmodal.nativeElement.click();
  }

}
